export const MEASUREMENT_REPORT_DOWNLOAD_ERROR_MESSAGE =
  "PDFのダウンロードに失敗しました。\n時間をおいて再度お試しください。"
